export type CmsAttributeValueType =
    | 'string'
    | 'number'
    | 'boolean'
    | 'enum'
    | 'url';

export const CMS_VALUE_TYPES = {
    String: 'string',
    Number: 'number',
    Boolean: 'boolean',
    Enum: 'enum',
    Url: 'url',
} as const satisfies Record<string, CmsAttributeValueType>;

export interface CmsAttributeManifest {
    propertyName?: string;
    attributeName: string;
    valueType: CmsAttributeValueType;
    allowedValues?: ReadonlyArray<string>;
}

export type CmsAllowedChildren = ReadonlyArray<string> | '*';

export type CmsContentMode = 'none' | 'children' | 'adapter';

export const CMS_CONTENT_MODES = {
    None: 'none',
    Children: 'children',
    Adapter: 'adapter',
} as const satisfies Record<string, CmsContentMode>;

export type CmsContentConfiguration =
    | { mode: typeof CMS_CONTENT_MODES.None }
    | {
          mode: typeof CMS_CONTENT_MODES.Children;
          allowedChildren?: CmsAllowedChildren;
      }
    | { mode: typeof CMS_CONTENT_MODES.Adapter; adapter: string };

export type CmsContentManifest =
    | { mode: typeof CMS_CONTENT_MODES.None }
    | {
          mode: typeof CMS_CONTENT_MODES.Children;
          allowedChildren: CmsAllowedChildren;
      }
    | { mode: typeof CMS_CONTENT_MODES.Adapter; adapter: string };

export interface CmsComponentManifest {
    attributes: ReadonlyArray<CmsAttributeManifest>;
    content: CmsContentManifest;
}

export type CmsComponentManifestRegistry = Readonly<
    Record<string, CmsComponentManifest>
>;

export type CmsAttributeConfiguration =
    | {
          exclude: true;
          attributeName?: never;
          valueType?: never;
          allowedValues?: never;
      }
    | {
          exclude?: false;
          attributeName?: string;
          valueType?: CmsAttributeValueType;
          allowedValues?: ReadonlyArray<string>;
      };
